import { Injectable } from "@angular/core";
import * as moment from "moment";
import { Subject } from "rxjs";
import { Constants } from "./Constants";

@Injectable({ providedIn: "root" })
export class UserDataService {
  private _userData: any = { rights: [] };
  private _serverTime = moment();
  private timeInterval: any = null;
  barrackChangeEvent = new Subject<Number>();

  constructor() {
    this._userData = { rights: [] };
  }

  set userData(userData: any) {
    this._userData = userData;
  }

  get userData() {
    return this._userData;
  }

  get serverTime() {
    return this._serverTime;
  }

  getElection(election_type: number): any {
    var election = null;
    this.userData.elections.forEach(function (elm) {
      if (elm.election_type == election_type) {
        election = elm;
        return false;
      }
    });
    return election;
  }

  getAssemblyElections(): any {
    var elections = [];
    // elections.push(this.getElection(Constants.LOKSABHA_ELECTION));
    elections.push(this.getElection(Constants.ASSEMBLY_ELECTION));
    return elections.filter(function (e) {
      return e != null;
    });
  }

  startServerTime(time: string) {
    if (this.timeInterval != null) {
      clearInterval(this.timeInterval);
    }
    this._serverTime = moment(time, "YYYY-MM-DD hh:mm:ss a");
    this.timeInterval = setInterval(() => {
      this._serverTime.add(1, "s");
    }, 1000);
  }

  logout() {}
}
